let authed = false;
if (localStorage.getItem("token")) {
  authed = true;
}
export default (state = authed, action) => {
  switch (action.type) {
    case "AUTH":
      return action.payload;
    case "DEAUTH":
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authenticationReducer.js